import { render, staticRenderFns } from "./S3Config.vue?vue&type=template&id=9767fc06&"
import script from "./S3Config.vue?vue&type=script&lang=js&"
export * from "./S3Config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports